import React from "react";

function More() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path fill="#fff" d="M0 0H24V24H0z"></path>
      <path
        fill="#F0B595"
        stroke="#F0B595"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M12 14a1 1 0 100-2 1 1 0 000 2zM12 6a1 1 0 100-2 1 1 0 000 2zM12 22a1 1 0 100-2 1 1 0 000 2z"
      ></path>
    </svg>
  );
}

export default More;
